import { setThing, SolidDataset, ThingLocal } from '@inrupt/solid-client'
import { reduce } from 'lodash'

export const updateDataset = (
  dataset: SolidDataset,
  things: ThingLocal[]
): SolidDataset => {
  return reduce(
    things,
    (acc: SolidDataset, cur: ThingLocal) => setThing(acc, cur),
    dataset
  )
}
